module.exports = __webpack_public_path__ + "static/media/adv-banner-img3.ff7c6f21.jpg";